import { tsValidateValue } from '@nu-art/ts-common';
import { EpicFhirAuthModes } from './types.js';
export const Validator_EpicFhirAuthMode = tsValidateValue([...EpicFhirAuthModes], false);
//# sourceMappingURL=validator.js.map